import { render, staticRenderFns } from "./CameraDialogHeader.vue?vue&type=template&id=70bf7796"
import script from "./CameraDialogHeader.vue?vue&type=script&lang=js"
export * from "./CameraDialogHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports